"use client";

const IntegrationPartnerLoadingDots = () => {
  return (
    <>
      <div className="flex items-center gap-1.5" aria-hidden="true">
        {[0, 1, 2, 3, 4].map((dot) => (
          <span
            key={dot}
            className="size-2 rounded-full bg-[#3BDAFF]"
            style={{
              opacity: 0.25 + dot * 0.12,
              animation: "loading-wave 0.9s ease-in-out infinite",
              animationDelay: `${dot * 0.12}s`,
            }}
          />
        ))}
      </div>

      <style jsx>{`
        @keyframes loading-wave {
          0%,
          100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-5px);
          }
        }
      `}</style>
    </>
  );
};

export default IntegrationPartnerLoadingDots;
